var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.576 30.7887C36.7475 30.7887 36.076 31.4602 36.076 32.2887C36.076 33.1171 36.7475 33.7887 37.576 33.7887V30.7887ZM18.8738 12.0618C18.0454 12.0618 17.3738 12.7334 17.3738 13.5618C17.3738 14.3903 18.0454 15.0618 18.8738 15.0618V12.0618ZM42.0605 30.7887H37.576V33.7887H42.0605V30.7887ZM43 29.846C43 30.3685 42.5775 30.7887 42.0605 30.7887V33.7887C44.2381 33.7887 46 32.0216 46 29.846H43ZM43 16.0045V29.846H46V16.0045H43ZM42.0605 15.0618C42.5775 15.0618 43 15.482 43 16.0045H46C46 13.8289 44.2381 12.0618 42.0605 12.0618V15.0618ZM18.8738 15.0618H42.0605V12.0618H18.8738V15.0618Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6878 17.0509L10.6587 12.4002C10.1943 11.8642 9.34272 11.8666 8.80322 12.4073L5.48996 15.7265C4.50385 16.7138 4.22159 18.1799 4.79206 19.3554C8.20014 26.4118 13.8911 32.1107 20.9427 35.5286C22.117 36.0991 23.5818 35.8168 24.568 34.8295L27.9122 31.4794C28.4541 30.9375 28.4553 30.0812 27.9146 29.6167L23.246 25.6091C22.7577 25.1899 21.9991 25.2447 21.5096 25.7354L19.8851 27.3622C19.8019 27.4494 19.6925 27.5068 19.5735 27.5258C19.4545 27.5447 19.3326 27.524 19.2265 27.467C16.5712 25.9379 14.3686 23.7324 12.843 21.0751C12.7858 20.9688 12.7651 20.8467 12.7841 20.7276C12.803 20.6084 12.8605 20.4987 12.9478 20.4153L14.5675 18.7944C15.0581 18.3014 15.1117 17.5392 14.6878 17.0497V17.0509Z",
    stroke: "#727272",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6aa76ceb6f49e55631d3aa275e20f71d.svg";
export { ForwardRef as ReactComponent };